/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_DescInputs */

const en_lg_search_desc = /** @type {(inputs: Lg_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search channel, DM, group, and thread messages with conversation and sender filters. Results follow your current access permissions.`)
};

const id_lg_search_desc = /** @type {(inputs: Lg_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari pesan channel, DM, grup, dan thread dengan filter percakapan serta pengirim. Hasil mengikuti izin aksesmu saat ini.`)
};

/**
* | output |
* | --- |
* | "Search channel, DM, group, and thread messages with conversation and sender filters. Results follow your current access permissions." |
*
* @param {Lg_Search_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_desc = /** @type {((inputs?: Lg_Search_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_desc(inputs)
	return en_lg_search_desc(inputs)
});